'use strict';

var React = require('react');

var SvgSidebarRightMajor = function SvgSidebarRightMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 1h-6.5v18h6.5a1.5 1.5 0 0 0 1.5-1.5v-15a1.5 1.5 0 0 0-1.5-1.5zm-16.5 1a1 1 0 0 1 1-1h2v2h-1v1h-2v-2zm1 17a1 1 0 0 1-1-1v-2h2v1h1v2h-2zm4-18h3v2h-3v-2zm3 16h-3v2h3v-2zm-6-11v3h-2v-3h2zm0 8v-3h-2v3h2z"
  }));
};

exports.SvgSidebarRightMajor = SvgSidebarRightMajor;
